import React from 'react';
import { TERMS_AND_CONDITIONS_URL } from '../../../../AppConstants';

function LicenceInfo({ fisheryId }) {
  const comptonsLake = 11833;

  return (
    <div id='summary-notice' className='mg-top-30 br20'>
      <p className='fs-15 fw6 mg-bottom-5 gBold'>IMPORTANT:</p>

      <ul>
        {+fisheryId !== comptonsLake && (
          <li className='fs-15 gSemiBold'>
            It is illegal to fish without a license in the UK. You can buy a
            fishing license from the government here (
            <a
              href='https://www.gov.uk/fishing-licences/buy-a-fishing-licence'
              target='_new'
            >
              Buy a rod fishing licence
            </a>
            ).
          </li>
        )}
        <li className='fs-15 gSemiBold'>
          Any changes or cancellations to your booking after payment and
          confirmation have to be made via the fishery. For swimbooker™ booking
          policies{' '}
          <a href={TERMS_AND_CONDITIONS_URL} target='_new'>
            click here
          </a>
          .
        </li>
      </ul>
    </div>
  );
}

export default LicenceInfo;
